"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _buttonDropdownItemModule = _interopRequireDefault(require("./button-dropdown-item.module.scss"));
const ButtonDropdownItem = _ref => {
  let {
    onClick,
    disabled,
    children
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_buttonDropdownItemModule.default.ButtonDropdownItem, {
      [_buttonDropdownItemModule.default.disabled]: disabled
    }),
    onClick: disabled ? undefined : onClick
  }, children);
};
ButtonDropdownItem.displayName = 'ButtonDropdownItem';
ButtonDropdownItem.propTypes = {
  children: _propTypes.default.node,
  onClick: _propTypes.default.func,
  disabled: _propTypes.default.bool
};
var _default = exports.default = ButtonDropdownItem;